import { render, staticRenderFns } from "./Shifokor.vue?vue&type=template&id=50f6edc5"
import script from "./Shifokor.vue?vue&type=script&lang=js"
export * from "./Shifokor.vue?vue&type=script&lang=js"
import style0 from "./Shifokor.vue?vue&type=style&index=0&id=50f6edc5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports